"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceError = void 0;
function getCircularReplacer() {
    const ancestors = [];
    return function (_key, value) {
        if (typeof value !== 'object' || value === null) {
            return value;
        }
        // `this` is the object that value is contained in,
        // i.e., its direct parent.
        while (ancestors.length > 0 && ancestors.at(-1) !== this) {
            ancestors.pop();
        }
        if (ancestors.includes(value)) {
            return '[Circular]';
        }
        ancestors.push(value);
        return value;
    };
}
class SourceError extends Error {
    constructor({ cause, code, message, type }) {
        super(message);
        this.code = null;
        this.cause = null;
        this.type = type !== null && type !== void 0 ? type : 'client_error';
        this.code = code !== null && code !== void 0 ? code : null;
        this.cause = cause !== null && cause !== void 0 ? cause : null;
    }
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types,
                      @typescript-eslint/no-unsafe-assignment,
                      @typescript-eslint/no-unsafe-member-access,
                      @typescript-eslint/no-explicit-any */
    static from(response) {
        // Log the response for debugging (remove in production)
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
            // eslint-disable-next-line no-console
            console.log('API Error Response:', JSON.stringify(response, getCircularReplacer(), 2));
        }
        const errorType = (response === null || response === void 0 ? void 0 : response.type) || 'api_error';
        const errorCode = (response === null || response === void 0 ? void 0 : response.code) || 'unknown_error';
        const errorMessage = (response === null || response === void 0 ? void 0 : response.message) || 'An unknown error occurred';
        // Validate the response structure
        if (!response || typeof response !== 'object') {
            return new SourceError({
                type: 'client_error',
                code: 'invalid_error_response',
                message: `Received invalid error response from API. Raw response: ${JSON.stringify(response, getCircularReplacer())}`,
            });
        }
        return new SourceError({
            type: errorType,
            code: errorCode,
            message: errorMessage,
        });
    }
}
exports.SourceError = SourceError;
